/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-11 18:21:22
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-05-27 16:42:30
 * @FilePath: /unifyxp-v2-store-portal/src/components/Modules/ResponsiveSubscription/index.tsx
 */
import { TextAlignment } from '@/src/components';
import CountWords from '@/src/components/CountWords/CountWords';
import { Row } from '@/src/components/Layouts';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { AnimationType } from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorAnimation/tool';
import { Icon } from '@/src/tools/icon';
import { cloneDeep, get, set, uniq } from 'lodash';
import React from 'react';
import { Checkbox, Input, Select } from 'src/components/Antd';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import DragNDropColumns, {
  EnumPosition,
} from 'src/components/DragNDropColumns';
// import FieldModal from 'src/components/FieldModal/Subscription';
import FieldContainer from 'src/components/DragRowDisplay/DoubleRowsTextAndEditIcon';
import TextOnlyContainer from 'src/components/DragRowDisplay/TextOnly';
import FieldModal from 'src/components/FieldModal';
import { EnumFieldType } from 'src/components/FieldModal/config';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Switcher from 'src/components/SectionSwitcher';
import Slider from 'src/components/Slider/MarginSlider';
import { Tag } from 'src/components/Tags/Tags';
import Editor from 'src/constrains/BraftEditor';
import { errKeys } from 'src/constrains/DraggableModules/tools';
import ModalHoc from 'src/constrains/ModalHOC';
import TCModals from 'src/constrains/TermsAndConditionsSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  EPreviewSize,
  SubscriptionBackgroundType,
  SubscriptionLayoutOption,
} from 'src/types/common/SalesChannel';
import { EnumModuleType } from 'src/types/common/module';
import css from './css.module.less';

const unDeletable = [EnumFieldType.Email];
const _errKeys = errKeys[EnumModuleType.ResponsiveSubscription];
const Subscription = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    staticData,
    onStaticChange,
    draggableId,
    tcsOptions,
    onItemDelete,
    onItemReselect,
    onItemSort,
    droppableId,
    onItemChange,
    onItemAdd,
    tacs = [],
    buttons = [],
    animations = [],
    hoverAnimations = [],
    fields = [],
    specificError,
    fieldsOptions = [],
    breakpoint,
    linkSet,
  } = props;

  const layoutErr = specificError[_errKeys.layoutOption] || [];
  const submitButtonTextErr = specificError[_errKeys.submitButtonText] || [];
  const submitButtonThemeErr = specificError[_errKeys.buttonThemeUuid] || [];
  const topPaddingErr = specificError[_errKeys.topPadding] || [];
  const bottomPaddingErr = specificError[_errKeys.bottomPadding] || [];
  const entranceUuidErr = specificError[_errKeys.entranceUuid] || [];
  const hoverEffectUuidErr = specificError[_errKeys.hoverEffectUuid] || [];
  const tcErr = specificError[_errKeys.termsAndConditions] || [];
  const [tcVisible, setTcVisible] = React.useState(false);
  const [fieldsVisible, setFieldsVisible] = React.useState(false);
  const [selectedField, setSelectedField] = React.useState<any>({});
  const [switcher, setSwitcher] = React.useState('moduleStyle');

  const generateAvailableField = (currentField?) => {
    const currentOccupiedField = fields.map((i) => {
      return get(i, 'field.uuid');
    });
    const _currentOccupiedField = currentOccupiedField.filter(
      (i) => i !== currentField,
    );
    const ava = fieldsOptions.filter((i) => {
      const type = get(i, 'uuid');
      return !_currentOccupiedField.includes(type);
    }); // difference(types, _currentOccupiedField);
    return ava;
  };
  const onFieldModalCancel = () => {
    setFieldsVisible(false);
    setSelectedField({});
  };
  const {
    layoutOption,
    text,
    submitButtonText,
    moduleStyle,
    buttonThemeUuid,
    subscriptionFormStyle,
    animation,
    fontSizeMultiply,
    textAlignment,
  } = staticData;

  const handleStaticChange = (prop: string, v: any) => {
    const temp = cloneDeep(staticData);
    set(temp, prop, v);
    onStaticChange(temp);
  };

  const handleOnTCReselect = (tc) => {
    // console.log(tc, 'tcs');
    const _tc = tc.map((i) => {
      const { uuid } = i;
      return { ...i, draggableId: uuid };
    });
    onItemReselect(_tc, 'tacs');
  };

  const handleOnTCDelete = (index) => {
    onItemDelete(index, 'tacs');
  };

  const handleOnTCSort = (sort) => {
    const { newIndex, oldIndex } = sort.data;
    onItemSort(oldIndex, newIndex, 'tacs');
  };

  const tcChildGenerate = (data, index) => {
    const { name } = data;
    return <TextOnlyContainer name={name} />;
  };

  const handleOnFieldDelete = (index) => {
    onItemDelete(index, 'fields');
  };

  const handleOnFieldSort = (sort) => {
    const { newIndex, oldIndex } = sort.data;

    onItemSort(oldIndex, newIndex, 'fields');
  };

  const handleOnFieldAdd = (field) => {
    onItemAdd([field], 'fields');
  };

  const handleOnFieldEdit = (index, field) => {
    onItemChange(index, field, 'fields');
  };

  const handleOnFieldOk = (field) => {
    const {
      draggableId,
      field: _field,
      required,
      dateOfBirthFields,
      isAddNew,
      index,
      placeholder,
    } = field;
    const currentField = get(_field, 'uuid');
    const _draggableId = draggableId || currentField;

    const obj = {
      draggableId: _draggableId,
      field: _field,
      required,
      dateOfBirthFields,
      placeholder,
    };
    if (isAddNew) {
      handleOnFieldAdd(obj);
    } else {
      handleOnFieldEdit(index, obj);
    }
    onFieldModalCancel();
  };

  const fieldChildGenerate = (data, index) => {
    const { field, required, dateOfBirthFields } = data;

    const currentField = get(field, 'fieldType');
    const currentUuid = get(field, 'uuid');
    const name = get(field, 'name');
    const ava = generateAvailableField(currentUuid);
    const className = unDeletable.includes(currentField)
      ? css.fieldContainer
      : '';
    return (
      <FieldContainer
        title={`${name} ${required ? '(required field)' : ''}`}
        name={`${name} ${dateOfBirthFields || ''}`}
        containerClassName={className}
        onClick={() => {
          setSelectedField({ ...data, index, availableFields: ava });
          setFieldsVisible(true);
        }}
      />
    );
  };

  const getAllAttributes = () => {
    return uniq(
      (tacs || []).reduce((pre, i) => {
        const _r = [...pre, ...(i.consentAttributes || [])];
        return _r;
      }, []),
    );
  };

  switch (breakpoint) {
    case EPreviewSize.WIDE: {
      return (
        <React.Fragment>
          {tcVisible && (
            <TCModals
              tcs={tcsOptions}
              selectedItems={tacs}
              onOk={handleOnTCReselect}
              onCancel={(e) => {
                setTcVisible(false);
              }}
              visible={tcVisible}
            />
          )}

          {fieldsVisible && (
            <FieldModal
              title={getI18n('general.customerinformationfield')}
              visible={fieldsVisible}
              {...selectedField}
              onOk={handleOnFieldOk}
              onCancel={onFieldModalCancel}
              placeholderRequired
            />
          )}

          <Section bottomBorder>
            <ItemWrapper title={`${getI18n('general.layoutOption')}*`}>
              <Select
                error={layoutErr.length > 0}
                help={layoutErr.join('')}
                size={'large'}
                options={[
                  {
                    label: getI18n('general.centredFormInOneColumn'),
                    value: SubscriptionLayoutOption.ONE_COLUMN,
                  },
                  {
                    label: getI18n('general.centredFormInTwoColumns'),
                    value: SubscriptionLayoutOption.TWO_COLUMN,
                  },
                  {
                    label: getI18n('general.textOnTheLeftFormOnTheRight'),
                    value: SubscriptionLayoutOption.LEFT_TEXT_RIGHT_FORM,
                  },
                ]}
                value={layoutOption}
                onChange={handleStaticChange.bind(null, 'layoutOption')}
              />
            </ItemWrapper>
          </Section>
          <Section bottomBorder>
            <ItemWrapper title={`${getI18n('general.text')}*`}>
              <Editor
                linkSet={linkSet}
                data={text}
                onChange={({ data }) => handleStaticChange('text', data)}
              />
            </ItemWrapper>
          </Section>
          <Section bottomBorder>
            <ItemWrapper title={getI18n('general.submitButtonTheme')}>
              <Select
                error={submitButtonThemeErr.length > 0}
                help={submitButtonThemeErr.join('')}
                size={'large'}
                options={[
                  ...buttons.map((v) => ({ label: v.name, value: v.uuid })),
                  { label: getI18n('general.status.none'), value: null },
                ]}
                onChange={(v: any) => handleStaticChange('buttonThemeUuid', v)}
                value={buttonThemeUuid}
              />
            </ItemWrapper>
            <ItemWrapper
              title={`${getI18n('general.submitButtonText')}*`}
              rightPart={
                <CountWords
                  count={(submitButtonText || '').length}
                  allCount={100}
                />
              }>
              <Input
                error={submitButtonTextErr.length > 0}
                help={submitButtonTextErr.join('')}
                size={'large'}
                value={submitButtonText}
                onChange={handleStaticChange.bind(null, 'submitButtonText')}
              />
            </ItemWrapper>
          </Section>
          <Section bottomBorder className={css.switcherContainer}>
            <Switcher
              selected={switcher}
              selectContainer={css.switcher}
              onChange={(v) => setSwitcher(v)}
              allSections={{
                moduleStyle: {
                  title: getI18n('general.moduleStyle'),
                  hasError:
                    topPaddingErr.length > 0 || bottomPaddingErr.length > 0,
                  child: (
                    <div className={css.paddingContainer}>
                      <Row
                        elements={[
                          {
                            child: (
                              <>
                                <ItemWrapper
                                  title={getI18n('general.topPadding')}>
                                  <Input
                                    error={topPaddingErr.length > 0}
                                    help={topPaddingErr.join('')}
                                    size={'large'}
                                    suffix={'px'}
                                    value={moduleStyle?.topPadding}
                                    onChange={(v: any) =>
                                      handleStaticChange(
                                        'moduleStyle.topPadding',
                                        v,
                                      )
                                    }
                                  />
                                </ItemWrapper>
                              </>
                            ),
                          },
                          {
                            child: (
                              <>
                                <ItemWrapper
                                  title={getI18n('general.bottomPadding')}>
                                  <Input
                                    error={bottomPaddingErr.length > 0}
                                    help={bottomPaddingErr.join('')}
                                    size={'large'}
                                    suffix={'px'}
                                    value={moduleStyle?.bottomPadding}
                                    onChange={(v: any) =>
                                      handleStaticChange(
                                        'moduleStyle.bottomPadding',
                                        v,
                                      )
                                    }
                                  />
                                </ItemWrapper>
                              </>
                            ),
                          },
                        ]}
                      />
                      <ItemWrapper title={'Background Type'}>
                        <Select
                          size={'large'}
                          options={[
                            {
                              label: 'None',
                              value: SubscriptionBackgroundType.NONE,
                            },
                            {
                              label: 'Colour',
                              value: SubscriptionBackgroundType.COLOR,
                            },
                          ]}
                          value={moduleStyle?.backgroundType}
                          onChange={(v: any) =>
                            handleStaticChange('moduleStyle.backgroundType', v)
                          }
                        />
                      </ItemWrapper>
                      <ItemWrapper title={''}>
                        <Checkbox
                          checked={moduleStyle?.fullWidth}
                          onChange={(checked) =>
                            handleStaticChange('moduleStyle.fullWidth', checked)
                          }>
                          {getI18n('general.fullwidthbackground')}
                        </Checkbox>
                      </ItemWrapper>
                      <Slider
                        value={moduleStyle?.marginToTop || 0}
                        title={getI18n('general.margintoTopEdge')}
                        customIcon={
                          <Icon type={'icontop1'} className={css.icon} />
                        }
                        onChange={(value) =>
                          handleStaticChange('moduleStyle.marginToTop', value)
                        }
                      />
                      <Slider
                        value={moduleStyle?.marginToBottom || 0}
                        title={getI18n('general.margintoBottomEdge')}
                        customIcon={
                          <Icon type={'icontop1'} className={css.icon} />
                        }
                        onChange={(value) =>
                          handleStaticChange(
                            'moduleStyle.marginToBottom',
                            value,
                          )
                        }
                      />
                      {moduleStyle?.backgroundType ===
                        SubscriptionBackgroundType.COLOR && (
                        <ItemWrapper
                          title={getI18n('general.backgroundColour')}>
                          <ColorPicker
                            multi
                            onChange={(v) =>
                              handleStaticChange(
                                'moduleStyle.backgroundColor',
                                v,
                              )
                            }
                            color={moduleStyle?.backgroundColor}
                          />
                        </ItemWrapper>
                      )}
                    </div>
                  ),
                },
                subscriptionFormStyle: {
                  title: 'Subscription Form Style',
                  hasError: false,
                  child: (
                    <div className={css.paddingContainer}>
                      <ItemWrapper title={'Input Field Outline Colour'}>
                        <ColorPicker
                          multi
                          onChange={(v) =>
                            handleStaticChange(
                              'subscriptionFormStyle.outlineColor',
                              v,
                            )
                          }
                          color={subscriptionFormStyle?.outlineColor}
                        />
                      </ItemWrapper>
                      <ItemWrapper
                        title={'Terms & Condition Text & Icon Colour'}>
                        <ColorPicker
                          multi
                          onChange={(v) =>
                            handleStaticChange(
                              'subscriptionFormStyle.tacTextAndIconColor',
                              v,
                            )
                          }
                          color={subscriptionFormStyle?.tacTextAndIconColor}
                        />
                      </ItemWrapper>
                    </div>
                  ),
                },
                animation: {
                  title: getI18n('general.sider.animation'),
                  hasError:
                    entranceUuidErr.legnth > 0 || hoverEffectUuidErr > 0,
                  child: (
                    <div className={css.paddingContainer}>
                      <ItemWrapper title={'Entrance Animation'}>
                        <Select
                          error={entranceUuidErr.length > 0}
                          help={entranceUuidErr.join('')}
                          size={'large'}
                          options={[
                            ...animations
                              .filter(
                                (v) =>
                                  v.animationType ===
                                  AnimationType.EntranceEffect,
                              )
                              .map((v) => ({ label: v.name, value: v.uuid })),
                            {
                              label: 'None',
                              value: null,
                            },
                          ]}
                          onChange={(v) =>
                            handleStaticChange('animation.entranceUuid', v)
                          }
                          value={animation?.entranceUuid}
                        />
                      </ItemWrapper>
                      <ItemWrapper title={'Hover Effect'}>
                        <Select
                          error={hoverEffectUuidErr.length > 0}
                          help={hoverEffectUuidErr.join('')}
                          size={'large'}
                          options={[
                            ...hoverAnimations.map((v) => ({
                              label: v.name,
                              value: v.uuid,
                            })),
                            {
                              label: 'None',
                              value: null,
                            },
                          ]}
                          onChange={(v) =>
                            handleStaticChange('animation.hoverEffectUuid', v)
                          }
                          value={animation?.hoverEffectUuid}
                        />
                      </ItemWrapper>
                    </div>
                  ),
                },
                customerInformationFields: {
                  title: 'Customer Information Fields',
                  hasError: false,
                  child: (
                    <React.Fragment>
                      <DragNDropColumns
                        titleRightTextClassName={css.editContainer}
                        hideTitle
                        childGenerate={fieldChildGenerate}
                        onDelete={handleOnFieldDelete}
                        data={fields.map((i) => {
                          const type = get(i, 'field.fieldType');
                          if (unDeletable.includes(type)) {
                            return { ...i, hideDelete: true };
                          }
                          return i;
                        })}
                        droppableId={`${droppableId}${draggableId}FieldDropArea`}
                        onSort={handleOnFieldSort}
                        onAdd={() => {
                          setSelectedField({
                            availableFields: generateAvailableField(),
                          });
                          setFieldsVisible(true);
                        }}
                        hideAdd={generateAvailableField().length === 0}
                        addTextPosition={EnumPosition.bottom}
                        addText={'+ Add Field'}
                      />
                    </React.Fragment>
                  ),
                },
                terms: {
                  title: 'Terms & Conditions',
                  hasError: tcErr.length > 0,
                  child: (
                    <React.Fragment>
                      <DragNDropColumns
                        errorInTitle={tcErr.join(' ')}
                        subTitle='Please add Terms & Condition with marketing consent attribute.'
                        titleRightTextClassName={css.editContainer}
                        //displayWarningModalWhenDeleting
                        hideTitleRightFunction
                        titleRightText='Edit'
                        childGenerate={tcChildGenerate}
                        onDelete={handleOnTCDelete}
                        data={tacs}
                        onAdd={() => setTcVisible(true)}
                        droppableId={`${droppableId}${draggableId}TCDropArea`}
                        onSort={handleOnTCSort}
                        addTextPosition={EnumPosition.bottom}
                        addText={'+ Add Terms & Conditions'}
                      />
                      <Section className={css.attContainer}>
                        <div className={css.title}>Consent Attribute</div>
                        {getAllAttributes().map((i: string) => {
                          return (
                            <Tag className={css.tag} closable={false} key={6}>
                              <NoWrapContainer>
                                <Tooltip title={i}>{i}</Tooltip>
                              </NoWrapContainer>
                            </Tag>
                          );
                        })}
                      </Section>
                    </React.Fragment>
                  ),
                },
              }}
            />
          </Section>
        </React.Fragment>
      );
    }
    case EPreviewSize.TABLET: {
      return (
        <React.Fragment>
          <Section bottomBorder>
            <ItemWrapper title={getI18n('general.text')}>
              <Editor disabled={true} linkSet={linkSet} data={text} />
            </ItemWrapper>
            <Slider
              max={1000}
              min={0}
              value={fontSizeMultiply || 0}
              title={getI18n('general.fontSizeMultiple')}
              customIcon={<Icon type={'icona-fontsize'} className={css.icon} />}
              onChange={(value) =>
                handleStaticChange('fontSizeMultiply', value)
              }
              suffix={'%'}
            />
            <ItemWrapper title={getI18n('general.textAlignment')}>
              <TextAlignment
                value={textAlignment}
                onChange={(value) => handleStaticChange('textAlignment', value)}
              />
            </ItemWrapper>
          </Section>
          <Section bottomBorder>
            <ItemWrapper title={'Submit Button Theme'}>
              <Select
                error={submitButtonThemeErr.legnth > 0}
                help={submitButtonThemeErr.join('')}
                size={'large'}
                options={buttons.map((v) => ({ label: v.name, value: v.uuid }))}
                onChange={(v: any) => handleStaticChange('buttonThemeUuid', v)}
                value={buttonThemeUuid}
              />
            </ItemWrapper>
          </Section>
          <Section bottomBorder>
            <Switcher
              selected={'moduleStyle'}
              allSections={{
                moduleStyle: {
                  title: getI18n('general.moduleStyle'),
                  hasError: true,
                  child: (
                    <React.Fragment>
                      <Row
                        elements={[
                          {
                            child: (
                              <ItemWrapper
                                title={getI18n('general.topPadding')}>
                                <Input
                                  error={topPaddingErr.legnth > 0}
                                  help={topPaddingErr.join('')}
                                  size={'large'}
                                  suffix={'px'}
                                  value={moduleStyle?.topPadding}
                                  onChange={(v: any) =>
                                    handleStaticChange(
                                      'moduleStyle.topPadding',
                                      v,
                                    )
                                  }
                                />
                              </ItemWrapper>
                            ),
                          },
                          {
                            child: (
                              <ItemWrapper
                                title={getI18n('general.bottomPadding')}>
                                <Input
                                  error={bottomPaddingErr.legnth > 0}
                                  help={bottomPaddingErr.join('')}
                                  size={'large'}
                                  suffix={'px'}
                                  value={moduleStyle?.bottomPadding}
                                  onChange={(v: any) =>
                                    handleStaticChange(
                                      'moduleStyle.bottomPadding',
                                      v,
                                    )
                                  }
                                />
                              </ItemWrapper>
                            ),
                          },
                        ]}
                      />
                      <ItemWrapper title={''}>
                        <Checkbox
                          checked={moduleStyle?.fullWidth}
                          onChange={(checked) =>
                            handleStaticChange('moduleStyle.fullWidth', checked)
                          }>
                          {getI18n('general.fullwidthbackground')}
                        </Checkbox>
                      </ItemWrapper>
                      <Slider
                        value={moduleStyle?.marginToTop || 0}
                        title={getI18n('general.margintoTopEdge')}
                        customIcon={
                          <Icon type={'icontop1'} className={css.icon} />
                        }
                        onChange={(value) =>
                          handleStaticChange('moduleStyle.marginToTop', value)
                        }
                      />
                      <Slider
                        value={moduleStyle?.marginToBottom || 0}
                        title={getI18n('general.margintoBottomEdge')}
                        customIcon={
                          <Icon type={'icontop1'} className={css.icon} />
                        }
                        onChange={(value) =>
                          handleStaticChange(
                            'moduleStyle.marginToBottom',
                            value,
                          )
                        }
                      />
                    </React.Fragment>
                  ),
                },
              }}
            />
          </Section>
        </React.Fragment>
      );
    }
    case EPreviewSize.MOBILE: {
      return (
        <React.Fragment>
          <Section bottomBorder>
            <ItemWrapper title={getI18n('general.text')}>
              <Editor disabled={true} linkSet={linkSet} data={text} />
            </ItemWrapper>
            <Slider
              max={1000}
              min={0}
              value={fontSizeMultiply || 0}
              title={getI18n('general.fontSizeMultiple')}
              customIcon={<Icon type={'icona-fontsize'} className={css.icon} />}
              onChange={(value) =>
                handleStaticChange('fontSizeMultiply', value)
              }
              suffix={'%'}
            />
            <ItemWrapper title={getI18n('general.textAlignment')}>
              <TextAlignment
                value={textAlignment}
                onChange={(value) => handleStaticChange('textAlignment', value)}
              />
            </ItemWrapper>
          </Section>
          <Section bottomBorder>
            <ItemWrapper title={'Submit Button Theme'}>
              <Select
                error={submitButtonThemeErr.legnth > 0}
                help={submitButtonThemeErr.join('')}
                size={'large'}
                options={buttons.map((v) => ({ label: v.name, value: v.uuid }))}
                onChange={(v: any) => handleStaticChange('buttonThemeUuid', v)}
                value={buttonThemeUuid}
              />
            </ItemWrapper>
          </Section>
          <Section bottomBorder>
            <Switcher
              selected={'moduleStyle'}
              allSections={{
                moduleStyle: {
                  title: getI18n('general.moduleStyle'),
                  hasError: false,
                  child: (
                    <React.Fragment>
                      <Row
                        elements={[
                          {
                            child: (
                              <ItemWrapper
                                title={getI18n('general.topPadding')}>
                                <Input
                                  error={topPaddingErr.legnth > 0}
                                  help={topPaddingErr.join('')}
                                  size={'large'}
                                  suffix={'px'}
                                  value={moduleStyle?.topPadding}
                                  onChange={(v: any) =>
                                    handleStaticChange(
                                      'moduleStyle.topPadding',
                                      v,
                                    )
                                  }
                                />
                              </ItemWrapper>
                            ),
                          },
                          {
                            child: (
                              <ItemWrapper
                                title={getI18n('general.bottomPadding')}>
                                <Input
                                  error={bottomPaddingErr.legnth > 0}
                                  help={bottomPaddingErr.join('')}
                                  size={'large'}
                                  suffix={'px'}
                                  value={moduleStyle?.bottomPadding}
                                  onChange={(v: any) =>
                                    handleStaticChange(
                                      'moduleStyle.bottomPadding',
                                      v,
                                    )
                                  }
                                />
                              </ItemWrapper>
                            ),
                          },
                        ]}
                      />
                      <ItemWrapper title={''}>
                        <Checkbox
                          checked={moduleStyle?.fullWidth}
                          onChange={(checked) =>
                            handleStaticChange('moduleStyle.fullWidth', checked)
                          }>
                          {getI18n('general.fullwidthbackground')}
                        </Checkbox>
                      </ItemWrapper>
                      <Slider
                        value={moduleStyle?.marginToTop || 0}
                        title={getI18n('general.margintoTopEdge')}
                        customIcon={
                          <Icon type={'icontop1'} className={css.icon} />
                        }
                        onChange={(value) =>
                          handleStaticChange('moduleStyle.marginToTop', value)
                        }
                      />
                      <Slider
                        value={moduleStyle?.marginToBottom || 0}
                        title={getI18n('general.margintoBottomEdge')}
                        customIcon={
                          <Icon type={'icontop1'} className={css.icon} />
                        }
                        onChange={(value) =>
                          handleStaticChange(
                            'moduleStyle.marginToBottom',
                            value,
                          )
                        }
                      />
                    </React.Fragment>
                  ),
                },
              }}
            />
          </Section>
        </React.Fragment>
      );
    }
    default: {
      return <React.Fragment></React.Fragment>;
    }
  }
};
export default ModalHoc(Subscription);
